<template>
  <div class="tab-content">
    <div class="meeting-section">
      <!-- 顶部操作区域 -->
<!--      <div class="meeting-header">-->
<!--        <span></span>-->
<!--        <Button v-if="userTaskPermissionList.includes('expert_group_review')" type="primary" @click="showCreateModal">创建会议</Button>-->
<!--      </div>-->
      
      <!-- 会议列表 -->
      <div class="meeting-list">
        <!-- 空状态提示 -->
        <div v-if="meetingList.length === 0" class="no-meeting">
          <p>暂无专家组评审会议</p>
        </div>
        <!-- 会议卡片列表 -->
        <div 
          v-for="record in meetingList" 
          :key="record.id" 
          class="meeting-card"
        >
          <!-- 头部会议名称区域 -->
          <div class="meeting-name-header">
            <span class="meeting-name-label">会议名称:</span>
            <span class="meeting-name-value">{{ record.meetingName }}</span>
            <span class="meeting-status" :class="getStatusClass(record.status)">
              {{ getStatusText(record.status) }}
            </span>
          </div>
          
          <!-- 主要信息区域 -->
          <div class="meeting-info-section">
            <div class="meeting-details">
              <div class="detail-item">
                <span class="detail-label">会议日期：</span>
                <span class="detail-value">{{ record.meetingDate || '-' }}</span>
              </div>
              <!-- <div class="detail-item">
                <span class="detail-label">实际开始时间：</span>
                <span v-if="record.status === 2" class="detail-value">{{ formatDateTime(record.actualStartTime) || '-' }}</span>
                <DatePicker v-else v-model:value="record.actualStartTime" show-time format="YYYY-MM-DD HH:mm" placeholder="选择开始时间" />
              </div>
              <div class="detail-item">
                <span class="detail-label">实际结束时间：</span>
                <span v-if="record.status === 2" class="detail-value">{{ formatDateTime(record.actualEndTime) || '-' }}</span>
                <DatePicker v-else v-model:value="record.actualEndTime" show-time format="YYYY-MM-DD HH:mm" placeholder="选择结束时间" />
              </div> -->
              <div class="detail-item">
                <span class="detail-label">会议评审结果：</span>
                <span class="detail-value">
                  <!-- 已结束会议显示文本结果 -->
                  <template v-if="record.status === 2">
                    {{ record.reviewResult === 1 ? '通过' : record.reviewResult === 0 ? '未通过' : '-' }}
                  </template>
                  <!-- 未结束会议显示单选按钮组 -->
                  <template v-else>
                    <div class="radio-group-wrapper">
                      <Radio.Group v-model:value="record.reviewResult">
                        <Radio :value="1">通过</Radio>
                        <Radio :value="0">未通过</Radio>
                      </Radio.Group>
                    </div>
                  </template>
                </span>
              </div>
              
              <!-- 文件信息 -->
              <div class="detail-item full-width" style="align-items: flex-start;">
                <span class="detail-label" style="align-self: flex-start; margin-top: 4px;">会议纪要：</span>
                <div class="detail-value" style="align-self: flex-start; margin-top: 4px;">
                  <span v-if="record.status === 2">{{ record.meetingSummary || '-' }}</span>
                  <Input.TextArea v-else v-model:value="record.meetingSummary" :rows="3" placeholder="请输入会议纪要" />
                </div>
              </div>
              
              <div class="detail-item full-width" style="align-items: flex-start;">
                <span class="detail-label" style="align-self: flex-start; margin-top: 4px;">专家组意见：</span>
                <div class="detail-value" style="align-self: flex-start; margin-top: 4px;">
                  <span v-if="record.status === 2">{{ record.expertOpinion || '-' }}</span>
                  <Input.TextArea v-else v-model:value="record.expertOpinion" :rows="3" placeholder="请输入专家组意见" />
                </div>
              </div>

            </div>
          </div>
          
          <!-- 会议附件区域 -->
          <div class="meeting-attachment-section">
            <div class="attachment-header" style="display: flex; justify-content: space-between; align-items: center;">
              <h4>会议附件</h4>
              <Button type="link" @click="handleDownloadAllAttachments(record)">全部下载</Button>
            </div>
            <div class="attachment-content">
              <MaterialFileManager
                  :materialId="record.id"
                  :initialFiles="record.attachments || []"
                  :supportedFormats="record.supportedFormats || []"
                  :edit="record.status === 1"
                  @update:files="(files, materialId) => handleFilesUpdate(materialId, files)"
                  @upload-success="handleUploadSuccess"
                  @delete="handleFileDelete"
              />
            </div>
          </div>
          
          <!-- 操作按钮区域（居右侧底部） -->
<!--          <div class="action-section">-->
<!--            <div class="action-buttons">-->
<!--              <Button -->
<!--                v-if="record.status === 1 && userTaskPermissionList.includes('expert_group_review')"-->
<!--                type="primary" -->
<!--                danger-->
<!--                @click="endMeeting(record)"-->
<!--              >-->
<!--                结束会议-->
<!--              </Button>-->
<!--              -->
<!--              <Button-->
<!--                v-if="userTaskPermissionList.includes('expert_group_review')"-->
<!--                type="default" -->
<!--                danger-->
<!--                @click="confirmDeleteMeeting(record)"-->
<!--              >-->
<!--                删除会议-->
<!--              </Button>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>

    <!-- 创建会议模态框 -->
    <Modal
      title="创建会议"
      v-model:open="createModalVisible"
      @ok="submitCreateMeeting"
      @cancel="createModalVisible = false"
      okText="确定"
      cancelText="取消"
    >
      <Form layout="vertical">
        <Form.Item label="会议名称" required>
          <Input v-model:value="createMeetingForm.meetingName" placeholder="请输入会议名称" />
        </Form.Item>
        <Form.Item label="会议日期" required>
          <DatePicker v-model:value="createMeetingForm.meetingDate" style="width: 100%;" placeholder="请选择会议日期" />
        </Form.Item>
      </Form>
    </Modal>
  </div>
</template>

<script setup name="MeetingTab">
import { ref, reactive, onMounted, defineProps, defineEmits } from 'vue';
import { Button, Modal, Form, Input, DatePicker, message, Radio, TimePicker } from 'ant-design-vue';
import MaterialFileManager from '@/components/MaterialFileManager/index.vue';
import {
  getReviewMeetingListByApplicationId,
  createReviewMeeting,
  deleteReviewMeetingById,
  overReviewMeeting
} from '@/api/application/reviewMeetings'

// 定义组件接收的props
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  userTaskPermissionList: {
    type: Array
  },
  editType: {
    type: Boolean,
    default: false
  }
});

// 定义事件
const emit = defineEmits(['upload-application-info']);

// 会议列表数据
const meetingList = ref([]);

// 模态框状态
const createModalVisible = ref(false);

// 创建会议表单
const createMeetingForm = reactive({
  meetingName: '',
  meetingDate: null
});

// 处理文件更新
//材料id为会议的id
const handleFilesUpdate = (materialId, files) => {
  console.log('文件列表已更新:', files.length, '会议ID:', materialId);
  // console.log("materialId.files", materialId, files);
  // console.log("meetingList", meetingList.value);
  // const meeting = meetingList.value.find(item => item.id === materialId);
  // if (meeting) {
  //   meeting.attachments = files;
  // }
  // console.log("meetingList", meetingList.value);
};

// 处理上传成功
const handleUploadSuccess = (file, materialId) => {
  console.log('文件上传成功:', file.name, '评审会议ID:', materialId);
  // 在文件上传成功后，查找对应的材料并更新其files属性
  const meeting = meetingList?.value?.find(item => item.id === materialId);
  if (meeting) {
    // 确保files是数组
    if (!Array.isArray(meeting.attachments)) {
      meeting.attachments = [];
    }
    // 检查是否已存在相同uid的文件，如果不存在则添加
    const existingFileIndex = meeting.attachments.findIndex(f => f.uid === file.uid);
    if (existingFileIndex === -1) {
      meeting.attachments.push(file);
    } else {
      // 如果文件已存在，则更新它
      meeting.attachments[existingFileIndex] = file;
    }
  }
};

// 处理文件删除
const handleFileDelete = (file, materialId) => {
  console.log('文件删除:', file.name, '会议ID:', materialId);
  // 在文件删除后，查找对应的材料并更新其files属性
  const meeting = meetingList?.value?.find(item => item.id === materialId);
  if (meeting && Array.isArray(meeting.attachments)) {
    // 过滤掉要删除的文件
    meeting.attachments = meeting.attachments.filter(f => f.uid !== file.uid);
    console.info(meeting.attachments, "meeting.files after delete");
  }
};

// 打开创建会议模态框
const showCreateModal = () => {
  resetForm();
  createModalVisible.value = true;
};

// 重置表单
const resetForm = () => {
  createMeetingForm.meetingName = '';
  createMeetingForm.meetingDate = null;
};

// 提交创建会议
const submitCreateMeeting = () => {
  // 表单验证
  if (!createMeetingForm.meetingName || !createMeetingForm.meetingDate) {
    message.error('请填写完整会议信息');
    return;
  }

  // 添加新会议
  const newMeeting = {
    id: null,
    applicationId: props.id,
    meetingName: createMeetingForm.meetingName,
    meetingDate: createMeetingForm.meetingDate.format('YYYY-MM-DD'),
    actualStartTime: null,
    actualEndTime: null,
    status: 1,
    reviewResult: null,
    meetingSummary: '',
    expertOpinion: '',
  };
  createReviewMeeting(newMeeting).then(res => {
    if (res.code === 200){
      createModalVisible.value = false;
      message.success('会议创建成功');
      resetForm();
      fetchMeetingData();
    }
  })
};

// 获取状态文本
const getStatusText = (status) => {
  switch (status) {
    case 1:
      return '---';
    case 2:
      return '已结束';
    default:
      return '-';
  }
};

// 获取状态样式类
const getStatusClass = (status) => {
  return status === 1 ? 'status-pending' : 'status-completed';
};

// 结束会议
const endMeeting = (record) => {

  // 添加新会议
  const overMeeting = {
    id: record.id,
    actualStartTime: formatDateTime(record.actualStartTime, true),
    actualEndTime: formatDateTime(record.actualEndTime, true),
    status: 2,
    reviewResult: record.reviewResult,
    meetingSummary: record.meetingSummary,
    expertOpinion: record.expertOpinion,
  };
  console.log("meetingList", meetingList.value)
  const meeting = meetingList.value.find(item => item.id === record.id);
  if (meeting) {
    overMeeting.attachments = meeting.attachments
  }
  overReviewMeeting(overMeeting).then(res => {
    if (res.code === 200 && res.data){
      fetchMeetingData();
      emit('update-application-info');
    }
  })
};

// 模拟获取数据
const fetchMeetingData = async () => {
  try {

    const res = await getReviewMeetingListByApplicationId(props.id)
    if (res.code === 200) {
      // 确保meetingList始终是一个数组
      meetingList.value = Array.isArray(res.data) ? res.data : [res.data];
    }
  } catch (error) {
    console.error('获取会议数据失败:', error);
    message.error('获取数据失败，请稍后重试');
  }
};

// 组件挂载时获取数据
onMounted(async () => {
  await fetchMeetingData();
});


// 确认删除会议
const confirmDeleteMeeting = (meeting) => {
   Modal.confirm({
     title: '确认删除',
     content: `确定要删除会议"${meeting.meetingName}"吗？此操作不可恢复。`,
     okText: '确认删除',
     okType: 'danger',
     cancelText: '取消',
     onOk() {
       deleteMeeting(meeting.id);
     },
   });
};
    
 // 删除会议
const deleteMeeting = async (id) => {
  try {
    // 这里应该调用实际的删除API
    console.log('删除会议ID:', id);
    // 假设API调用成功后，从列表中移除
    const res = await deleteReviewMeetingById(id);
    if (res.code === 200 && res.data){
      message.success('会议删除成功');
      await fetchMeetingData();
    }
  } catch (error) {
    console.error('删除会议失败:', error);
    message.error('删除会议失败，请稍后重试');
  }
};

// 下载单个会议的所有附件
const handleDownloadAllAttachments = (meeting) => {
  try {
    // 检查当前会议是否有附件
    const attachments = meeting.attachments;
        
    if (attachments && attachments.length > 0) {
      message.info('正在准备全部下载，请稍候...');
          
      // 遍历所有附件并下载
      attachments.forEach(attachment => {
        // 创建下载链接并点击
        const link = document.createElement('a');
        link.href = attachment.url;
        link.download = attachment.name;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
          
      message.success(`已开始下载 ${attachments.length} 个附件`);
    } else {
      message.warning('当前会议暂无附件');
    }
  } catch (error) {
    console.error('下载附件失败:', error);
    message.error('下载附件失败，请重试');
  }
};
// 格式化日期时间函数
const formatDateTime = (dateTime, includeSeconds = false) => {
  if (!dateTime) return '';
  
  try {
    // 如果是字符串格式的时间，尝试进行转换
    if (typeof dateTime === 'string') {
      // 如果是纯时间格式(HH:mm:ss)，直接返回
      if (/^\d{2}:\d{2}:\d{2}$/.test(dateTime)) {
        return dateTime;
      }
    }
    
    // 如果是Date对象或可以转换为日期的格式
    const date = new Date(dateTime);
    if (!isNaN(date.getTime())) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      if (includeSeconds) {
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } else {
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      }
    }
    
    return dateTime; // 如果无法格式化，返回原始值
  } catch (error) {
    console.error('日期格式化错误:', error);
    return dateTime;
  }
};
</script>

<style scoped lang="less">
.tab-content {
  background: #fff;
  padding: 15px;
  margin-bottom: 80px;
}

.meeting-section {
  background: #fff;
  border-radius: 4px;
}

.meeting-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 5px 20px;
  border-bottom: 1px solid #e8e8e8;
}

.meeting-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.meeting-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.no-meeting {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}

.meeting-card {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.meeting-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

// 会议名称头部区域
.meeting-name-header {
  background-color: #fafafa;
  padding: 12px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.meeting-name-label {
  font-size: 14px;
  color: #666;
  margin-right: 8px;
}

.meeting-name-value {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  flex: 1;
}

.meeting-status {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-pending {
  background-color: #e6f7ff;
  color: #1890ff;
}

.status-completed {
  background-color: #f6ffed;
  color: #52c41a;
}

// 会议信息区域
.meeting-info-section {
  padding: 12px;
}

// 会议附件区域样式
.meeting-attachment-section {
  border-top: 1px solid #e8e8e8;
  margin-top: 16px;
  padding-top: 16px;
  margin-left: 12px;
}

.attachment-header {
  margin-bottom: 12px;
}

.attachment-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.attachment-content {
  margin-top: 8px;
}

.meeting-details {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 50px;
}

.detail-item {
    display: flex;
    align-items: center;
  }

  .detail-item.full-width {
    min-width: 100%;
    width: 100%;
  }

  .detail-label {
    width: 100px;
    font-weight: 500;
    display: flex;
    align-items: center;
    color: #666;
    font-size: 14px;
    margin-right: 10px;
  }

  .detail-value {
    flex: 1;
    display: flex;
    align-items: center;
    color: #333;
    font-size: 14px;
    min-width: 150px;
  }

.action-section {
  padding: 12px;
  border-top: 1px solid #e8e8e8;
  background-color: #fafafa;
  display: flex;
  justify-content: flex-end;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.radio-group-wrapper {
  display: flex;
  align-items: center;
  padding-bottom: 7px;
}

.radio-group-wrapper :deep(.ant-radio-group) {
  display: flex;
  align-items: center;
}
</style>